<div class="flex w-[360px] flex-col overflow-hidden bg-white ring-1 ring-black/5">
  <!-- Header -->
  <div class="flex items-center justify-between border-b border-gray-100 bg-gray-50/80 px-4 py-3 backdrop-blur-sm">
    <div class="flex items-center gap-2">
      <h3 class="text-xs font-bold uppercase tracking-wider text-content-secondary">Notificações</h3>
      @if ((unreadCount$ | async) ?? 0 > 0) {
      <span
        class="inline-flex items-center rounded-full bg-color-brand/10 px-1.5 py-0.5 text-xs font-bold text-color-brand"
      >
        {{ unreadCount$ | async }} novas
      </span>
      }
    </div>
    <!-- Mark all as read button -->
    @if ((unreadCount$ | async) ?? 0 > 0) {
    <button
      (click)="onMarkAllAsRead()"
      class="flex h-6 w-6 items-center justify-center rounded-lg text-gray-400 transition-all hover:bg-gray-100 hover:text-color-brand active:scale-95"
      title="Marcar todas como lidas"
    >
      <app-icon name="tick" size="0.875rem" />
    </button>
    }
  </div>

  <!-- List -->
  <div
    class="flex max-h-[380px] flex-col overflow-y-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-200 hover:scrollbar-thumb-gray-300"
  >
    @for (notification of notifications$ | async; track notification.id) {
    <div
      class="group relative flex gap-3 border-b border-gray-150 p-3 transition-all hover:bg-gray-50/80"
      [ngClass]="{ 'bg-color-brand/[0.02]': !notification.lida, 'cursor-pointer hover:bg-color-brand/5': notification.navegavel }"
      [attr.role]="notification.navegavel ? 'button' : null"
      [attr.tabindex]="notification.navegavel ? 0 : null"
      (click)="aoClicarNotificacao(notification)"
      (keydown.enter)="aoClicarNotificacao(notification)"
    >
      <!-- Icon Status -->
      <div class="flex-shrink-0 pt-0.5">
        <div
          class="flex h-7 w-7 items-center justify-center rounded-lg transition-colors"
          [ngClass]="{
            'bg-green-50 text-green-600': notification.icon === 'tick',
            'bg-red-50 text-red-600': notification.icon === 'huge_alert_02',
            'bg-color-brand/10 text-color-brand': notification.icon === 'notifications',
            'bg-blue-50 text-blue-600': notification.icon === 'reload'
          }"
        >
          <app-icon
            [name]="notification.icon"
            size="1rem"
            class="h-4 w-4"
            [class]="notification.icon === 'reload' ? 'animate-spin' : ''"
          />
        </div>
      </div>

      <!-- Content -->
      <div class="flex flex-1 flex-col gap-0.5">
        <div class="flex items-start justify-between gap-2">
          <p class="text-xs font-semibold leading-tight text-content-primary">
            {{ notification.titulo }}
          </p>
          <span class="text-xs font-medium text-content-tertiary whitespace-nowrap">
            {{ notification.criadoEm | date : 'HH:mm' }}
          </span>
        </div>

        <p class="text-xs leading-snug text-content-secondary line-clamp-2">
          {{ notification.conteudo }}
        </p>
      </div>

      <!-- Unread Indicator -->
      @if (!notification.lida) {
      <div class="absolute right-3 top-3.5">
        <span class="block h-1.5 w-1.5 rounded-full bg-color-brand ring-2 ring-white"></span>
      </div>
      }
    </div>
    } @empty {
    <div class="flex flex-col items-center justify-center py-12 text-center">
      <div class="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-gray-50 text-gray-300">
        <app-icon name="notifications" size="1.5rem" class="h-6 w-6" />
      </div>
      <h3 class="text-xs font-bold text-content-primary">Tudo limpo!</h3>
      <p class="text-xs text-content-tertiary leading-relaxed">Nenhuma nova notificação.</p>
    </div>
    }
  </div>

  <!-- Footer -->
  <div class="flex flex-col gap-2 border-t border-gray-100 bg-gray-50/50 p-2">
    @if ((notifications$ | async)?.length) {
    <button
      (click)="onLoadMore()"
      class="flex w-full items-center justify-center rounded-lg bg-white border border-gray-200 py-2 text-xs font-bold text-content-secondary shadow-sm transition-all hover:bg-gray-50 hover:text-content-primary hover:border-gray-300 active:bg-gray-100"
    >
      Ver mais
    </button>
    }
    <button
      (click)="verTodas()"
      class="flex w-full items-center justify-center gap-1 rounded-lg py-2 text-xs font-bold text-color-brand transition-all hover:bg-color-brand/5"
    >
      <span>Ver todas as notificações</span>
      <app-icon name="arrow_right" size="0.75rem" class="h-3 w-3" />
    </button>
  </div>
</div>
